/**
 * ค่าเดียวกับ storeAuthority.level ที่ BE รับ/คืน — ALL_STORE ก็ส่งเป็น level เช่นกัน (scopes เป็น [] เสมอ)
 */
export enum AuthorityLevelEnum {
  ALL_STORE = 'ALL_STORE',
  REGIONAL_OFFICE = 'REGIONAL_OFFICE',
  REGIONAL_MANAGER = 'REGIONAL_MANAGER',
  AREA_MANAGER = 'AREA_MANAGER',
  STORE = 'STORE'
}
